import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMarkerBox = styled(Box)(({ theme }) => ({
  '&.PLWMarkerCard': {
    position: 'relative',
    width: theme.typography.pxToRem(32),
    height: theme.typography.pxToRem(42),
    '& .PLWPin': {
      width: '100%',
      height: '100%',
    },
    '&.PLWActiveMarker': {
      zIndex: 1,
      '& .PLWPin': {
        '& path': {
          fill: theme.palette.primary.main,
        },
        '& rect': {
          fill: theme.palette.common.black,
        },
      },
    },
  },
}));
